import React from 'react';
import classNames from 'classnames';

import styles from './index.sass';
import projectsDef from './projects.svg'

export default () =>
    <section className={styles.root}>
        <div dangerouslySetInnerHTML={{__html: projectsDef}} />
        <h3 className="g-type-title-section line-flat">Nasze pozostałe projekty</h3>
        <div>
            {projects.map((project, i) =>
                <a key={i} href={project.href}>
                    {/*<img className={project.imgClass} /> */}
                    {project.svg !== undefined &&
                    <svg viewBox="0 0 100 100" dangerouslySetInnerHTML={{__html: `<use xlink:href="${project.svg}" /><use xlink:href="${project.svg}" />`}} />
                    }
                    <h4 className="g-type-title-section">{project.name}</h4>
                    <p>{project.description}</p>
                </a>
            )}
        </div>
    </section>

const projects = [
    {
        name: 'Enclave Games',
        href: 'http://enclavegames.com',
        description: 'Indie Game Development Studio focused on mobile HTML5 games',
        svg: `#shape-enclave`
    },
    {
        name: 'Gamedev.js Weekly',
        href: 'http://gamedevjsweekly.com',
        description: 'Weekly newsletter about HTML5 Game Development',
        svg: `#shape-gdjs-weekly`
    },
    {
        name: 'js13kGames',
        href: 'http://js13kgames.com',
        description: 'HTML5 and JavaScript Game Development Competition in just 13 kB',
        svg: `#shape-js13k`
    },
    {
        name: 'HTML5 Gamedev Starter',
        href: 'http://html5devstarter.enclavegames.com',
        description: 'Starter for the new HTML5 game developers',
        svg: `#shape-starter`
    },
    {
        name: 'Open HTML5 Games',
        href: 'http://openhtml5games.com',
        description: 'Free mobile HTML5 games with open source code',
        svg: `#shape-open`
    },
    {
        name: 'Build HTML5 Games for Firefox OS',
        href: 'http://firefoxos.enclavegames.com',
        description: 'Free ebook about HTML5 Game Development for the Firefox OS',
        svg: `#shape-ebook`
    },
    {
        name: 'GameDev T-shirts!',
        description: 'Coming soon!',
        svg: `#shape-shirts`
    },
    /*
    {
        name: 'GameDev.js Meetups',
        href: 'http://gamedevjs.com',
        description: 'Polish meetups teaching people how to code HTML5 games',
        imgClass: styles.imgMeetups,
        svg: `<use xlink:href="#shape-meetups" />`
    },
    */
    {
        name: 'NeuroshimaHex.pl',
        href: 'http://neuroshimahex.pl',
        description: 'Polish website about the Neuroshima Hex board game',
        svg: `#shape-neuroshima`
    },
];



// WEBPACK FOOTER //
// ./src/pages/Home/elements/Projects/index.js